module.exports = __webpack_public_path__ + "img/button_max.50fde4ad.png";